import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=a5ecc53c&scoped=true&"
import script from "./invoice.vue?vue&type=script&lang=js&"
export * from "./invoice.vue?vue&type=script&lang=js&"
import style0 from "./invoice.vue?vue&type=style&index=0&id=a5ecc53c&lang=less&scoped=true&"
import style1 from "./invoice.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ecc53c",
  null
  
)

export default component.exports